import styled from 'styled-components';

export const EmptyState = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 40px 20px;
	text-align: center;
	height: 100%;
`;

export const EmptyStateIcon = styled.div`
	margin-bottom: 16px;
	opacity: 0.6;
`;

export const EmptyStateText = styled.div`
	font-size: 16px;
	font-weight: 600;
	color: ${({ theme }) => theme.gray[800]};
	margin-bottom: 8px;
`;

export const EmptyStateSubtext = styled.div`
	font-size: 13px;
	color: ${({ theme }) => theme.gray[600]};
	line-height: 20px;
	max-width: 280px;
`;
